import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib';

export interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  clearAriaLabel?: string;
  className?: string;
}

export function SearchBox({ value, onChange, placeholder, ariaLabel, clearAriaLabel, className }: SearchBoxProps) {
  const { t } = useTranslation();
  const defaultClearLabel = clearAriaLabel || t('common.clear', 'Clear');

  return (
    <div className={cn('relative', className)}>
      <div className="absolute inset-y-0 start-0 flex items-center pointer-events-none z-20 ps-3.5">
        <Search className="size-4 text-onsurface/40" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="py-1.5 sm:py-2 ps-10 pe-8 block w-full bg-field border-transparent rounded-lg sm:text-sm placeholder:text-onfield/40 focus:bg-field focus:border-primary focus:ring-primary checked:border-primary disabled:opacity-50 disabled:pointer-events-none text-onsurface"
        placeholder={placeholder}
        aria-label={ariaLabel}
      />
      {value && (
        <div className="absolute inset-y-0 end-0 flex items-center z-20 pe-1">
          <button
            type="button"
            onClick={() => onChange('')}
            className="inline-flex shrink-0 justify-center items-center size-6 rounded-full text-onsurface/40 hover:text-primary focus:outline-hidden focus:text-primary"
            aria-label={defaultClearLabel}
          >
            <span className="sr-only">{defaultClearLabel}</span>
            <svg
              className="shrink-0 size-4"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6" />
              <path d="m9 9 6 6" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}
